import React, { useContext } from 'react';
import { GlobalContext } from '../../contexts/GlobalContext';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import PageTitle from '../../components/PageTitle/PageTitle';
import ResponsiveImage from "../../components/ResponsiveImage/ResponsiveImage";
import '../../components/Accordion/Accordion.css'


const Fleet = ({ beforeRoute, title }) => {
    const { state } = useContext(GlobalContext);
    const language = state.language || 'pt-br';
    const data = require(`../../assets/languages/${language}/fleet.json`);
    const {
        selectedPage,
        breadCrumbImage,
        pageTitle,
        pageSubtitle,
        specifications,
    } = data
    const _beforeRoutes = [
        {
            "label": "Home",
            "value": "/"
        }
    ]
    if (beforeRoute) _beforeRoutes.push({
        "label": beforeRoute,
        "value": null,
        "disabled": true
    })

    return (

        <>
            <Breadcrumb
                beforeRoutes={_beforeRoutes}
                selectedPage={selectedPage}
                image={breadCrumbImage}
                ignoreMgBot={true}
                classColor='white100'
            />
            <div className='main-container' style={{
                minHeight: 'calc(100vh - var(--height-header) - 462px)'
            }}>
                <section className="section-container">
                    <PageTitle title={pageTitle} subtitle={pageSubtitle} />
                    <div className="mg-bot-100">
                    <ResponsiveImage image={'cubage-air-plane.png'} height='350px'/>
                    </div>
                    <div className='mg-bot-150'>
                    {
                        specifications.map((d, i) => <li key={i} className="accordion accordion-header"><span dangerouslySetInnerHTML={{ __html: d.content }} /></li>)
                    }
                    </div>
                </section>
            </div>
        </>
    )
}

export default Fleet